export const Branding = window.Branding || {
  Id: 1,
  Name: "Exista Business Solutions LLC",
  CompanyName: "Exista Business Solutions LLC",
  Contact: {
    Phone: "tel:201015471713",
    WhatsApp: "https://wa.me/201148371185",
    FaceBook: "https://www.facebook.com/futuresolutionsdev",
  },
};

export const Styles = {
  colors: {
    primary: "#38B2AC",
    secondary: "#319795",
    background: "#1A202C",
    text: "#E2E8F0",
  },
  fontSizes: {
    heading: "3xl",
    subheading: "lg",
    input: "md",
  },
  fontWeights: {
    heading: "bold",
    text: "normal",
  },
  button: {
    bg: "teal.400",
    hover: "teal.600",
    active: "teal.500",
  },
};
